// import Vue from 'vue'
import { createStore } from 'vuex'
import axios from 'axios'
import appSettings from '../../public/appSettings.json'
import userPreferences from './userPreferences'
//

export default createStore({
  modules: {
    userPreferences
  },
  state: {
    baseDomain: null,
    //'http://65.0.107.182:10000/api'
    baseDomain: (process.env.NODE_ENV === 'development'
    // ? 'http://localhost:20000/api'
    ? 'https://uat.htechonline.com/api'
    : appSettings.baseDomain),
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
    // Global date selection criteria
    globalDateRange: {
      dateRangeType: 'MTD',
      customStartDate: '',
      customEndDate: '',
      dateRange: {
        startDate: null,
        endDate: null
      }
    },
    // Dashboard navigation filters
    dashboardNavigationFilters: null
  },
  mutations: {
    auth_request (state) {
      state.status = 'loading'
      // state.baseDomain = (process.env.NODE_ENV === 'development'
      // ? 'http://localhost:20000/api'
      // : appSettings.baseDomain)
    },
    auth_success (state, token, user) {
      state.status = 'success'
      state.token = token
      state.user = user
    },
    auth_error (state) {
      state.status = 'error'
      alert('Invalid User ID or Password')
    },
    logout (state) {
      state.status = ''
      state.token = ''
    },
    // Global date range mutations
    set_global_date_range_type (state, dateRangeType) {
      state.globalDateRange.dateRangeType = dateRangeType
    },
    set_global_custom_start_date (state, customStartDate) {
      state.globalDateRange.customStartDate = customStartDate
    },
    set_global_custom_end_date (state, customEndDate) {
      state.globalDateRange.customEndDate = customEndDate
    },
    set_global_date_range (state, dateRange) {
      state.globalDateRange.dateRange = dateRange
    },
    set_global_date_range_settings (state, settings) {
      state.globalDateRange = { ...state.globalDateRange, ...settings }
    },
    // Dashboard navigation filters mutation
    set_dashboard_navigation_filters (state, filters) {
      state.dashboardNavigationFilters = filters
    }
  },
  actions: {
    login ({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        // var baseDomain = ''
        // if (process.env.NODE_ENV === 'development') {
        //   baseDomain = 'http://localhost:5000/api/Auth'
        // } else if (process.env.NODE_ENV === 'production') {
        //   baseDomain = 'http://149.129.129.112:51000/api/Auth'
        // }
        axios({ url: this.getters.baseDomain + '/Auth', headers: { 'Content-Type': 'application/json', 'No-Auth': 'True', 'Accept': 'application/json' }, data: JSON.stringify(user), method: 'POST' })
          .then(response => {
            const token = response.data.value.token
            const user = response.data.value.user
            localStorage.setItem('token', token)
            axios.defaults.headers.common['Authorization'] = token
            commit('auth_success', token, user)
            resolve(response)
          })
          .catch(err => {
            commit('auth_error')
            // localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    sendOTP ({ commit }, email) {
      return new Promise((resolve, reject) => {
        axios({ url: this.getters.baseDomain + '/Auth/sendOTP', headers: { 'Content-Type': 'application/json', 'No-Auth': 'True', 'Accept': 'application/json' }, data: JSON.stringify(email), method: 'POST' })
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            commit('auth_error')
            reject(err)
          })
      })
    },
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    }
  },
  getters: {
    baseDomain: state => state.baseDomain,
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    authToken: state => state.token,
    user: state => state.user,
    // Global date range getters
    globalDateRange: state => state.globalDateRange,
    globalDateRangeType: state => state.globalDateRange.dateRangeType,
    globalCustomStartDate: state => state.globalDateRange.customStartDate,
    globalCustomEndDate: state => state.globalDateRange.customEndDate,
    globalDateRangeDates: state => state.globalDateRange.dateRange,
    // Dashboard navigation filters getter
    dashboardNavigationFilters: state => state.dashboardNavigationFilters
  }
})
